(function () {
'use strict';
var dataEl = document.getElementById('mv-data');
if (!dataEl) return;
var DATA = {};
try { DATA = JSON.parse(dataEl.textContent) || {}; } catch (e) { return; }
var V = DATA.variants || [];
var SLIDE = { 'Бяла': 0, 'Черна': 1 };
var MAXN = 200;
var EXTRA = 'Допълнителна карта';
var state = { color: 'Бяла', n: 2, custom: 5, rating: 0, cartCards: 0, cartColor: null };
var chain = Promise.resolve();
var lastCart = null;
var pendingN = null;
var drawer = document.getElementById('mv-drawer');
var A_NAME = 'Име на бизнеса в Google Maps', A_LINK = 'Линк към Google Maps', A_PHONE = 'Телефон';

function $(s, r) { return (r || document).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
function setText(s, t) { var el = $(s); if (el) el.textContent = t; }
function eur(c) { c = Math.round(c || 0); var e = c / 100; return (c % 100 === 0 ? String(e) : e.toFixed(2).replace('.', ',')) + ' €'; }
function packN(v) { return v.pack === EXTRA ? 1 : parseInt(v.pack, 10); }
function packLabel(n) { return n === 1 ? '1 карта' : n + ' карти'; }
function clampN(n) { n = parseInt(n, 10); if (!(n >= 1)) n = 1; return Math.min(n, MAXN); }
function variant(color, n) { if (n === 'x') { for (var j = 0; j < V.length; j++) { if (V[j].color === color && V[j].pack === EXTRA) return V[j]; } return null; } for (var i = 0; i < V.length; i++) { if (V[i].color === color && V[i].pack !== EXTRA && packN(V[i]) === n) return V[i]; } return null; }
function byId(id) { for (var i = 0; i < V.length; i++) { if (V[i].id === id) return V[i]; } return null; }
function ok(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); }
function cartGet() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(ok); }
function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(ok); }
function showErr() { var el = $('[data-mv-cart-err]'); if (el) { el.hidden = false; setTimeout(function () { el.hidden = true; }, 4000); } return loadCart().catch(function () {}); }
function enqueue(fn) { chain = chain.then(fn).catch(showErr); return chain; }
function currentN() { return state.n === 'custom' ? state.custom : state.n; }
function knownCart() { return lastCart ? Promise.resolve(lastCart) : cartGet(); }

function packsFor(N) {
var out = [], q4 = Math.floor(N / 4), r = N % 4;
if (q4) { out.push([4, q4]); if (r) out.push(['x', r]); return out; }
if (r === 3) { out.push([3, 1]); r = 0; }
if (r >= 2) { out.push([2, 1]); r -= 2; }
if (r === 1) out.push([1, 1]);
return out;
}
function priceFor(color, N) {
var price = 0, compare = 0, avail = true, parts = packsFor(N);
for (var i = 0; i < parts.length; i++) {
var v = variant(color, parts[i][0]);
if (!v) return null;
if (!v.available) avail = false;
price += v.price * parts[i][1];
compare += (v.compare > v.price ? v.compare : v.price) * parts[i][1];
}
return { price: price, compare: compare, available: avail };
}
// FAST: one request instead of four. /cart/update.js removes old packs and adds new ones in one go and returns the cart.
function setCart(color, N) {
return knownCart().then(function (cart) {
var u = {};
cart.items.forEach(function (i) { if (byId(i.variant_id)) u[i.variant_id] = 0; });
packsFor(N).forEach(function (p) { var v = variant(color, p[0]); if (v) u[v.id] = p[1]; });
return post('/cart/update.js', { updates: u });
}).then(function (cart) { render(cart); return cart; });
}

function prefill(sel, key, cart) {
var el = $(sel);
if (el && !el.value && cart.attributes && cart.attributes[key]) el.value = cart.attributes[key];
}

// Instant visual update before the server answers.
function optimistic(color, n) {
var pr = priceFor(color, n);
if (!pr) return;
var extra = 0;
if (lastCart) lastCart.items.forEach(function (i) { if (!byId(i.variant_id)) extra += i.line_price; });
state.cartCards = n;
setText('[data-mv-cqty-n]', String(n));
setText('[data-mv-sub]', eur(pr.price));
setText('[data-mv-total]', eur(pr.price + extra));
setText('.mv-line__meta', packLabel(n) + ' · ' + color + ' карта');
var lp = $('.mv-line__price');
if (lp) lp.innerHTML = (pr.compare > pr.price ? '<s>' + eur(pr.compare) + '</s>' : '') + '<b>' + eur(pr.price) + '</b>';
$$('[data-mv-switch]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-mv-switch'), 10) === n)); });
var fill = $('[data-mv-ship-bar]');
if (fill) fill.style.width = (n >= 4 ? 100 : n * 25) + '%';
}

function render(cart) {
lastCart = cart;
$$('[data-mv-count]').forEach(function (el) { el.textContent = cart.item_count; });
var cards = 0, sum = 0, cmpSum = 0, color = null;
cart.items.forEach(function (i) {
var v = byId(i.variant_id);
if (!v) return;
cards += i.quantity * packN(v);
sum += i.line_price;
cmpSum += (v.compare > v.price ? v.compare : v.price) * i.quantity;
if (!color) color = v.color;
});
if (pendingN !== null) return; // a newer change is still on its way; don't flicker back
state.cartCards = cards;
state.cartColor = color;
var sticker = DATA.sticker ? cart.items.filter(function (i) { return i.variant_id === DATA.sticker.id; })[0] : null;
var express = DATA.express ? cart.items.filter(function (i) { return i.variant_id === DATA.express.id; })[0] : null;
var box = $('[data-mv-lines]');
if (box) {
if (!cards) { box.innerHTML = `<p class='mv-empty'>Количката е празна.</p>`; }
else {
var thumb = DATA.thumbs ? DATA.thumbs[SLIDE[color] || 0] : '';
var cmp = cmpSum > sum ? `<s>${eur(cmpSum)}</s>` : '';
box.innerHTML = `<div class='mv-line'>${thumb ? `<img src='${thumb}' alt='' width='72' height='72'>` : `<span class='mv-line__ph'></span>`}<div><p class='mv-line__title'>QR карта за Google отзиви</p><p class='mv-line__meta'>${packLabel(cards)} · ${color} карта</p><p class='mv-line__free'>Зареждане и тест на линка — безплатно</p></div><p class='mv-line__price'>${cmp}<b>${eur(sum)}</b></p></div>`;
}
}
$$('[data-mv-switch]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-mv-switch'), 10) === cards)); });
setText('[data-mv-cqty-n]', String(cards));
var cq = $('[data-mv-cqty-box]');
if (cq) cq.hidden = !cards;
var up = $('[data-mv-upsell]');
if (up) {
var target = cards === 1 ? 2 : ((cards === 2 || cards === 3) ? 4 : 0);
var tp = target && color ? priceFor(color, target) : null;
up.hidden = !tp;
if (tp) {
var upBtn = $('[data-mv-upgrade]');
if (upBtn) upBtn.setAttribute('data-mv-upgrade', String(target));
setText('[data-mv-upsell-text]', 'Вземи ' + target + ' карти — само ' + eur(tp.price - sum) + ' повече — ' + eur(tp.price / target) + ' на карта' + (target === 4 ? ' и безплатна доставка.' : '.'));
}
}
var fill = $('[data-mv-ship-bar]');
if (fill) fill.style.width = (cards >= 4 ? 100 : cards * 25) + '%';
setText('[data-mv-ship-text]', cards >= 4 ? 'Доставката е безплатна' : 'Вземи 4 карти и доставката е безплатна');
var sb = $('[data-mv-sticker]');
if (sb) { sb.setAttribute('aria-pressed', String(!!sticker)); sb.textContent = sticker ? 'Добавено' : '+ Добави'; }
var ec = $('[data-mv-express]');
if (ec) ec.checked = !!express;
setText('[data-mv-sub]', eur(sum));
setText('[data-mv-addsum]', sticker ? eur(sticker.line_price) : '—');
setText('[data-mv-expsum]', express ? eur(express.line_price) : '—');
setText('[data-mv-ship-cost]', cards >= 4 ? 'Безплатно' : 'от 3,90 €');
setText('[data-mv-total]', eur(cart.total_price));
var head = $('.mv-drawer__head [data-mv-bar-label]');
if (head) head.textContent = cards ? packLabel(cards) + ' · ' + color : '';
prefill('[data-mv-biz]', A_NAME, cart);
prefill('[data-mv-gurl]', A_LINK, cart);
prefill('[data-mv-phone]', A_PHONE, cart);
var nt = $('[data-mv-note]');
if (nt && !nt.value && cart.note) nt.value = cart.note;
}

function loadCart() { return cartGet().then(function (cart) { render(cart); return cart; }); }
function refresh() { return enqueue(loadCart); }

function openDrawer() {
if (!drawer) return;
drawer.hidden = false;
document.body.classList.add('mv-lock');
setTimeout(function () { drawer.classList.add('is-open'); }, 10);
var c = $('[data-mv-close-first]');
if (c) c.focus();
}
function closeDrawer() {
if (!drawer) return;
drawer.classList.remove('is-open');
document.body.classList.remove('mv-lock');
setTimeout(function () { drawer.hidden = true; }, 300);
}

function addPack() {
var N = currentN();
if (!priceFor(state.color, N)) return;
enqueue(function () { return setCart(state.color, N).then(openDrawer); });
}
// Rapid clicks are merged: the screen updates instantly, only the last number is sent.
function switchPack(n) {
n = clampN(n);
var color = state.cartColor || state.color;
optimistic(color, n);
var queued = pendingN !== null;
pendingN = n;
if (queued) return;
enqueue(function () {
var target = pendingN;
return setCart(color, target).then(function (cart) {
if (pendingN === target) { pendingN = null; render(cart); }
else { var next = pendingN; pendingN = null; switchPack(next); }
}, function (err) { pendingN = null; throw err; });
});
}
function toggleAddon(item) {
if (!item) return;
enqueue(function () {
return knownCart().then(function (cart) {
var has = cart.items.some(function (i) { return i.variant_id === item.id; });
var u = {}; u[item.id] = has ? 0 : 1;
return post('/cart/update.js', { updates: u });
}).then(function (cart) { render(cart); return cart; });
});
}
function mark(input, errEl, bad) {
if (errEl) errEl.hidden = !bad;
if (input) { if (bad) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
}
function checkout(e) {
e.preventDefault();
var nameIn = $('[data-mv-biz]');
var linkIn = $('[data-mv-gurl]');
var phoneIn = $('[data-mv-phone]');
var noteIn = $('[data-mv-note]');
var name = nameIn ? nameIn.value.trim() : '';
var link = linkIn ? linkIn.value.trim() : '';
var phone = phoneIn ? phoneIn.value.trim() : '';
var note = noteIn ? noteIn.value.trim() : '';
var nameBad = !name;
var linkBad = !/(google\.[a-z.]+\/maps|maps\.google\.|goo\.gl|g\.page|maps\.app)/i.test(link);
var phoneBad = phone.replace(/\D/g, '').length < 9;
mark(nameIn, $('[data-mv-biz-err]'), nameBad);
mark(linkIn, $('[data-mv-gurl-err]'), linkBad);
mark(phoneIn, $('[data-mv-phone-err]'), phoneBad);
if (nameBad) { if (nameIn) nameIn.focus(); return; }
if (linkBad) { if (linkIn) linkIn.focus(); return; }
if (phoneBad) { if (phoneIn) phoneIn.focus(); return; }
var attrs = {};
attrs[A_NAME] = name;
attrs[A_LINK] = link;
attrs[A_PHONE] = phone;
enqueue(function () {
return post('/cart/update.js', { attributes: attrs, note: note })
.then(function () { window.location.href = '/checkout'; });
});
}

function setColor(c) {
state.color = c;
$$('[data-mv-color]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mv-color') === c)); });
$$('[data-mv-color-name]').forEach(function (el) { el.textContent = c; });
showSlide(SLIDE[c] || 0);
updatePrices();
}
function setPackSel(n) {
state.n = n;
$$('[data-mv-pack]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mv-pack') === String(n))); });
var cb = $('[data-mv-custom-box]');
if (cb) cb.hidden = n !== 'custom';
updatePrices();
}
function setCustom(n) {
state.custom = clampN(n);
var inp = $('[data-mv-custom-n]');
if (inp && String(inp.value) !== String(state.custom)) inp.value = state.custom;
if (state.n !== 'custom') setPackSel('custom'); else updatePrices();
}
function showSlide(i) {
var slides = $$('[data-mv-slide]');
if (!slides.length) return;
if (i < 0 || i >= slides.length) i = 0;
slides.forEach(function (s, k) { s.hidden = k !== i; });
$$('[data-mv-thumb]').forEach(function (t, k) { t.setAttribute('aria-pressed', String(k === i)); });
}
function updatePrices() {
var N = currentN();
var pr = priceFor(state.color, N);
var price = pr ? pr.price : 0;
$$('[data-mv-price]').forEach(function (el) { el.textContent = eur(price); });
$$('[data-mv-bar-price]').forEach(function (el) { el.textContent = eur(price); });
$$('.mv-stickybar [data-mv-bar-label]').forEach(function (el) { el.textContent = packLabel(N) + ' · ' + state.color; });
$$('[data-mv-add]').forEach(function (b) { b.disabled = !pr || !pr.available; });
$$('[data-mv-pack]').forEach(function (b) {
var key = b.getAttribute('data-mv-pack');
var n = key === 'custom' ? state.custom : parseInt(key, 10);
var cp = priceFor(state.color, n);
var now = $('.mv-pack__now', b);
var old = $('.mv-pack__old', b);
if (cp && now) now.textContent = eur(cp.price);
if (old) old.textContent = cp && cp.compare > cp.price ? eur(cp.compare) : '';
if (key === 'custom') {
var per = $('[data-mv-custom-per]', b);
if (per && cp) per.textContent = n + ' карти · ' + eur(cp.price / n) + ' / бр.';
}
});
}

function setRating(n) {
state.rating = n;
$$('[data-mv-star]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-mv-star'), 10) <= n)); });
}
function submitReview(e) {
e.preventDefault();
var f = e.target;
var err = $('[data-mv-review-error]');
var done = $('[data-mv-review-ok]');
var name = f.elements.name.value.trim();
var text = f.elements.text.value.trim();
var msg = '';
if (state.rating < 1 || state.rating > 5) msg = 'Избери оценка от 1 до 5 звезди.';
else if (!name) msg = 'Напиши името си.';
else if (!text) msg = 'Напиши няколко думи за отзива.';
if (msg) { err.textContent = msg; err.hidden = false; if (done) done.hidden = true; return; }
err.hidden = true;
var body = new URLSearchParams();
body.append('form_type', 'contact');
body.append('utf8', '✓');
body.append('contact[name]', name);
body.append('contact[email]', DATA.email || '');
body.append('contact[body]', 'Отзив · ' + state.rating + ' от 5 · ' + text);
fetch('/contact', { method: 'POST', body: body, headers: { Accept: 'text/html' } })
.then(function (r) { if (!r.ok) throw new Error('send'); f.reset(); setRating(0); f.hidden = true; if (done) done.hidden = false; })
.catch(function () { err.textContent = 'Нещо се обърка. Опитай пак.'; err.hidden = false; });
}

function onClick(e) {
var t = e.target;
function hit(s) { return t && t.closest ? t.closest(s) : null; }
var el;
if ((el = hit('[data-mv-color]'))) return setColor(el.getAttribute('data-mv-color'));
if ((el = hit('[data-mv-pack]'))) { var k = el.getAttribute('data-mv-pack'); return setPackSel(k === 'custom' ? 'custom' : parseInt(k, 10)); }
if ((el = hit('[data-mv-qty]'))) return setCustom(state.custom + parseInt(el.getAttribute('data-mv-qty'), 10));
if ((el = hit('[data-mv-cqty]'))) { var nn = state.cartCards + parseInt(el.getAttribute('data-mv-cqty'), 10); if (nn >= 1) switchPack(nn); return; }
if (hit('[data-mv-add]')) return addPack();
if ((el = hit('[data-mv-thumb]'))) return showSlide(parseInt(el.getAttribute('data-mv-thumb'), 10));
if (hit('[data-mv-open-cart]')) { openDrawer(); return refresh(); }
if (hit('[data-mv-close]')) return closeDrawer();
if ((el = hit('[data-mv-switch]'))) return switchPack(parseInt(el.getAttribute('data-mv-switch'), 10));
if ((el = hit('[data-mv-upgrade]'))) return switchPack(parseInt(el.getAttribute('data-mv-upgrade'), 10));
if (hit('[data-mv-sticker]')) return toggleAddon(DATA.sticker);
if (hit('[data-mv-checkout]')) return checkout(e);
if (hit('[data-mv-review-open]')) { var f = $('[data-mv-review-form]'); if (f) { f.hidden = false; f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
if (hit('[data-mv-review-cancel]')) { var f2 = $('[data-mv-review-form]'); if (f2) f2.hidden = true; return; }
if ((el = hit('[data-mv-star]'))) return setRating(parseInt(el.getAttribute('data-mv-star'), 10));
if ((el = hit('[data-mv-review-more]'))) { $$('[data-mv-more]').forEach(function (r) { r.hidden = false; }); el.hidden = true; return; }
}
function onChange(e) {
var t = e.target;
if (t && t.matches && t.matches('[data-mv-express]')) toggleAddon(DATA.express);
if (t && t.matches && t.matches('[data-mv-custom-n]')) setCustom(t.value);
}
function onInput(e) {
var t = e.target;
if (t && t.matches && t.matches('[data-mv-custom-n]')) { var v = parseInt(t.value, 10); if (v >= 1) { state.custom = Math.min(v, MAXN); if (state.n !== 'custom') setPackSel('custom'); else updatePrices(); } }
}
function onSubmit(e) {
var t = e.target;
if (t && t.matches && t.matches('[data-mv-review-form]')) submitReview(e);
}
function onKey(e) {
if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
}

function init() {
document.addEventListener('click', onClick);
document.addEventListener('change', onChange);
document.addEventListener('input', onInput);
document.addEventListener('submit', onSubmit);
document.addEventListener('keydown', onKey);
if ($('[data-mv-bar]')) document.body.classList.add('mv-has-bar');
setColor(state.color);
setPackSel(state.n);
setRating(0);
refresh();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();